import {Link} from "react-router-dom";
import React from "react";
import {ProductCardList} from "./_components/ProductCardList";
import {usePublicTagList} from "../../hooks/usePublicEndpoint";
import {TipsCard} from "./_components/TipsCard";
import {ABCardShop} from "./_components/ABShop";

export function ShopWindow() {
    const {value: tagList, loadingValue: tagLoading, errorValue: tagError} = usePublicTagList()
    const sortedTags = tagList.sort((a, b) => b.product_count - a.product_count).filter((item, index) => index < 5)


    return (
        <>
            <div className="d-flex align-items-center justify-content-center m-4">
                <div className="d-flex flex-wrap justify-content-center gap-2">
                    <ArrowLink to="/shop/products" name="All Products" variant="success"/>
                    {sortedTags.map(tag => <ArrowLink to={`/shop/products?tags=${tag.id}`} name={tag.name}/>)}
                </div>
            </div>

            <TitleSections title="Our Latest Products"/>
            <ABCardShop styleWidth={null}>
                <ProductCardList/>
            </ABCardShop>

            <TitleSections title="Tips and News"/>
            <TipsCard/>

        </>
    )
}

function ArrowLink({to, name, variant = "primary"}) {
    return <Link to={to} className={`px-1 fs-5 fw-medium text-${variant} link-body-emphasis icon-link icon-link-hover text-decoration-none`}>
        {name}
        <svg xmlns="http://www.w3.org/2000/svg" className="bi" viewBox="0 0 16 16" aria-hidden="true">
            <path
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
        </svg>
    </Link>
}

function TitleSections({title, className}) {
    return <div className={`text-start fs-4 fw-medium my-2 ms-2 ms-sm-0 ${className}`}>{title}</div>
}

